import { useMemo } from "react";
import {
  useFetchActions,
  ACTION_TYPE_SLUG,
  type Action,
} from "@core/features/actions";
import { usePlatformStore } from "@platform/store";
import { SurveysTabContent } from "./SurveysTabContent";

export type Props = {
  /** Program ID */
  programId: number;
};

/**
 * Container for the Surveys tab.
 * Fetches MEETING_SURVEY actions and renders them as an action list.
 */
export function SurveysTabContentContainer({ programId }: Props) {
  const user = usePlatformStore((s) => s.user);

  const { data: actionsData } = useFetchActions({
    programId,
    user,
    isEnabled: !!user && !!programId,
  });

  const surveyActions = useMemo(() => {
    if (!actionsData?.actions) return [];
    return actionsData.actions.filter(
      (action: Action) =>
        action.action_type?.slug === ACTION_TYPE_SLUG.MEETING_SURVEY &&
        action.target_object_id,
    );
  }, [actionsData?.actions]);

  return <SurveysTabContent surveyActions={surveyActions} />;
}

export default SurveysTabContentContainer;
